import axios from "axios";
import { handleResponseErrorMessage } from "./response";
import authServices from "@/services/auth";
// create an axios instance
const service = axios.create({
  withCredentials: false, // send cookies when cross-domain requests
  timeout: 60000 * 30, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    const accessToken = authServices.loginInfo()
      ? authServices.loginInfo().access_token
      : "";
    config.headers["Content-Type"] = "multipart/form-data";
    config.headers["Access-Control-Allow-Origin"] = "*";
    config.headers["Authorization"] = `${accessToken}`;
    config.headers["Locale"] = "en";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    return res;
  },
  (error) => {
    return Promise.reject(handleResponseErrorMessage(error));
  }
);

export default service;
